module.exports = __webpack_public_path__ + "img/banner-telesalud3.88835aea.png";